/**
 * Adapted from the algorithmic-forecasts pitch mockup (DAS-6548),
 * rescaled from its 24x24 source to the 16x16 grid.
 */
export function TrendUpIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      aria-label="Trend up"
      focusable="false"
    >
      <path
        d="M2.7 11.3 5.3 6.7 7.3 9.4 10 4.1 13.3 8.1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="13.3" cy="8.1" r="1.3" fill="currentColor" />
    </svg>
  );
}
